var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLocked = function SvgIconLocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.28H28.3125V5.92C28.3125 2.65013 25.6266 0 22.3125 0H10.6875C7.37344 0 4.6875 2.65013 4.6875 5.92V16.28H1.5C0.670312 16.28 0 16.9414 0 17.76V35.52C0 36.3386 0.670312 37 1.5 37H31.5C32.3297 37 33 36.3386 33 35.52V17.76C33 16.9414 32.3297 16.28 31.5 16.28ZM8.0625 5.92C8.0625 4.49088 9.23906 3.33 10.6875 3.33H22.3125C23.7609 3.33 24.9375 4.49088 24.9375 5.92V16.28H8.0625V5.92ZM29.625 33.67H3.375V19.61H29.625V33.67ZM15.1875 27.2413V29.6925C15.1875 29.896 15.3562 30.0625 15.5625 30.0625H17.4375C17.6437 30.0625 17.8125 29.896 17.8125 29.6925V27.2413C18.1994 26.9671 18.4883 26.579 18.6374 26.1326C18.7865 25.6862 18.7882 25.2047 18.6423 24.7573C18.4964 24.3099 18.2103 23.9198 17.8254 23.643C17.4404 23.3662 16.9763 23.2171 16.5 23.2171C16.0237 23.2171 15.5596 23.3662 15.1746 23.643C14.7897 23.9198 14.5036 24.3099 14.3577 24.7573C14.2118 25.2047 14.2135 25.6862 14.3626 26.1326C14.5118 26.579 14.8006 26.9671 15.1875 27.2413Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-locked.9c3edc8c.svg";
export { ForwardRef as ReactComponent };